<template>
  <div class="box" :style="'top:' + boxPosition + '%'">
    <div class="im-title">日本語でユーザー対応</div>
    <div class="im-demo">
      サポートデスクは日本語で対応。旅行・出張・駐在・留学等の目的で中国に滞<br>在する日本人の“困った”を一気に解決します。
    </div>
    <div class="im-image">
      <img :src="im" />
    </div>
    
  </div>
</template>
<script>
import { im } from "../../images/home/index";
export default {
  data() {
    return {
      boxPosition: "100",
      im,
      
    };
  },
  methods: {
    init() {
      // this.isCanvasShow = true
      // this.$nextTick(() => {
      //   RENDERER.init(document.getElementsByClassName('canvas-area')[0])
      // })
    },
    up() {
      this.boxPosition = "-100";
      // RENDERER.stop()
      // this.isCanvasShow = false
    },
    nomal() {
      this.boxPosition = "0";
      // this.init()
    },
    down() {
      this.boxPosition = "100";
      // RENDERER.stop()
      // this.isCanvasShow = false
    },
  },
};
</script>
<style scoped>
.box {
  background: #eef2ff;
  padding-top: 0.5rem;
}
.im-title {
  font-size: 0.35rem;
  font-weight: bold;
  text-align: center;
  width: 5rem;
  position: relative;
  letter-spacing: 0.05rem;
  margin: 0 auto;
  margin-top: 0.5rem;
  line-height: 0.5rem;
  height: 0.5rem;
  color: rgba(7, 7, 7, 1);
  z-index: 1;
}
.im-title::before {
  content: "CUSTOMER SERVICE";
  color: rgba(49, 57, 80, 1);
  opacity: 0.1;
  position: absolute;
  width: 5rem;
  text-align: center;
  left: 0;
  top: 0;
  line-height: 0.2rem;
  letter-spacing: 0.05rem;
}
.im-image {
  text-align: center;
  position: absolute;
  z-index: 0;
  width: 8rem;
  left: 50%;
  margin-left: -4rem;
  height: 100%;
  padding-top: 3.5rem;
  top: 0;
}
.im-image img {
  display: block;
  height: auto;
  width: 100%;
  margin: 0 auto;
}
.im-demo {
  width: 8rem;
  text-align: center;
  font-weight: bold;
  font-size: 0.2rem;
  margin: 0 auto;
  margin-top: 0.35rem;
}

</style>


// WEBPACK FOOTER //
// src/components/home/modules/im-introduction.vue